import { Action, createReducer, on } from '@ngrx/store'
import {
  fetch_employee_with_reference_details_success,
  load_employee_summary_success_action
} from '../action/employee.action'
import { EmployeeState, initialEmployeeState } from '../state/employee.state'
import { EmployeeData } from 'src/app/models/api.model'

export function employeeReducer(state: EmployeeState, action: Action) {
  return _employeeReducer(state, action)
}

export const _employeeReducer = createReducer(
  initialEmployeeState,
  on(load_employee_summary_success_action, (state, { employee }) => {
    return {
      ...state,
      details: employee
    }
  }),
  on(fetch_employee_with_reference_details_success, (state, employeeData: EmployeeData) => {
    return {
      ...state,
      ...employeeData.employeeOrchModel,
      employeeComplianceReferenceDetailsOrchModel: employeeData.employeeComplianceReferenceDetailsOrchModel,
      employeeBankDetailsOrchModel: employeeData.employeeBankDetailsOrchModel
    }
  })
)
